var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcmsMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_4504_39417)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 10.7021C21.2543 10.7021 18.209 13.7475 18.209 17.4934C18.209 21.1678 21.0828 24.1417 24.8287 24.2704C24.9431 24.2561 25.0574 24.2561 25.1432 24.2704C25.1718 24.2704 25.1861 24.2704 25.2147 24.2704C25.229 24.2704 25.229 24.2704 25.2433 24.2704C28.9034 24.1417 31.7772 21.1678 31.7915 17.4934C31.7915 13.7475 28.7462 10.7021 25.0002 10.7021Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.264 28.0736C28.275 25.4143 21.7697 25.4143 17.7521 28.0736C15.9364 29.2889 14.9355 30.9331 14.9355 32.6916C14.9355 34.4502 15.9364 36.0801 17.7378 37.2811C19.7395 38.6251 22.3702 39.297 25.0009 39.297C27.6316 39.297 30.2623 38.6251 32.264 37.2811C34.0654 36.0658 35.0663 34.4359 35.0663 32.6631C35.052 30.9045 34.0654 29.2746 32.264 28.0736Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4504_39417",
    x1: 7.59804,
    y1: 1.75021e-7,
    x2: 39.7059,
    y2: 56.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08E1AE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcmsMe);
export default __webpack_public_path__ + "static/media/acms-me.a203556fcef5741c61c90af75401988e.svg";
export { ForwardRef as ReactComponent };